/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CsrfTokenInfo
 */
export interface CsrfTokenInfo {
    /**
     * 
     * @type {string}
     * @memberof CsrfTokenInfo
     */
    token: string;
}

export function CsrfTokenInfoFromJSON(json: any): CsrfTokenInfo {
    return CsrfTokenInfoFromJSONTyped(json, false);
}

export function CsrfTokenInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsrfTokenInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function CsrfTokenInfoToJSON(value?: CsrfTokenInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

